module.exports = __webpack_public_path__ + "media/images/icons/min-4f8c967c8b8f5836ead239628287308c.svg";